import { Color, ResponsiveAttribute } from '../../../basic';
import { IChainstore } from '../../../chainstores/chainstore';
import { ISides } from '../../../configs/config';
import { GsStructComponent, GsStructVerticalAlignment } from '../component';

export interface ICompanyInfoRender {
  items: unknown;
  infos: IChainstore[];
}

export interface GsStructCompanyInfoComponent extends GsStructComponent<ICompanyInfoRender> {
  componentType: 'CompanyInfo';
  // Map height in pixels
  mapHeight: ResponsiveAttribute<number>;
  // Map zoom level
  mapZoom: number;
  // Box on the map with contact details or text
  showBox: boolean;
  // Box alignment, left or right
  boxAlignment: GsStructCompanyInfoElementPosition;
  // Box vertical alignment, top or bottom
  boxInnerVerticalAlignment: GsStructVerticalAlignment;
  // Box width (column width for the box) x/12
  boxWidth?: number;
  // Box padding
  boxPadding: ISides;
  // Box background color
  boxBackgroundColor: Color;
  // Box content mode, text or contact or nothing
  boxContentMode: GsStructCompanyInfoBoxContent;
  // Title of the box
  boxTitle: string;
  // Box Title size
  boxTitleSize: GsStructCompanyInfoTitleSize;
  // Box Title boldness
  boxTitleBold: boolean;
  // Box Title uppercase or not
  boxTitleUppercase: boolean;
  // Box text, if mode is text
  boxText: string;
  // Adding the link to the box
  showLink: boolean;
  // Text for the link
  linkText: string;
  // Make the link as a button
  showLinkAsButton: boolean;
  // Style of the button, make it rounded
  roundedButton: boolean;
  // Show address in contact details
  showAddress: boolean;
  // Title for the address
  addressTitle: string;
  // Show contact information
  showContact: boolean;
  // Show phone number of contact
  showPhone: boolean;
  // Show fax number of contact
  showFax: boolean;
  // Show email address of contact
  showEmail: boolean;
  // Show opening hours in the contact box
  showOpeningHours: boolean;
  // Title for the opening hours
  openingHoursTitle: string;
  // Show the hours when the store is not open
  showClosingHours: boolean;
  // Show the box with icons, like phone, email, etc.
  showBoxIcons: boolean;
}

export enum GsStructCompanyInfoBoxContent {
  contact = 0,
  text = 1,
  none = 2
}

export enum GsStructCompanyInfoTitleSize {
  normal = 0,
  large = 1,
  extraLarge = 2,
  extremelyLarge = 3
}

// Element position for components
export enum GsStructCompanyInfoElementPosition {
  left = 0,
  right = 1
}
